import { Link, useNavigate, useLocation } from "react-router-dom"
import { useState, useEffect } from "react";
import { FaPlus, FaBox, FaMapMarkerAlt, FaUser, FaSignOutAlt, FaBars, FaTimes, FaEdit, FaTrash, FaHeart, FaTicketAlt, FaPhone } from 'react-icons/fa';
import Footer from "./component/Footer";
import AccountSidebar from "./component/AccountSidebar";
import userProfile, { deleteAddress } from "./services/userProfile";
import Swal from "sweetalert2";
import api from './api';
import axios from "axios";

const MyAddress = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [address, setAddress] = useState([]);
    const [loading, setLoading] = useState(false);
    const [usersaddress, setAddressData] = useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [mobileView, setMobileView] = useState("content");

    // Selected address driven purely by isDefault from API
    const [selectedAddressForOrder, setSelectedAddressForOrder] = useState(null);

    const [formData, setFormData] = useState({
        fullName: "",
        phone: "",
        pincode: "",
        city: "",
        state: "",
        houseName: "",
        address: "",
        landmark: "",
        addressType: "",
        isDefault: false,
        addressId: null,
    });

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => {
        setShowModal(false);
        setIsEditing(false);
        setFormData({
            fullName: "", phone: "", pincode: "", city: "", state: "",
            houseName: "", address: "", landmark: "", addressType: "",
            isDefault: false, addressId: null,
        });
    };

    const handleScrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
        const toggleVisibility = () => setIsVisible(window.pageYOffset > 300);
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    useEffect(() => {
        if (sessionStorage.getItem("mob_nav_direct") === "true") {
            sessionStorage.removeItem("mob_nav_direct");
        }
        setMobileView("content");
    }, [location.key]);

    // ✅ Clean: only use isDefault from API, no localStorage
    const autoSelectAddress = (addresses) => {
        if (!addresses || addresses.length === 0) {
            setSelectedAddressForOrder(null);
            return;
        }
        const defaultAddr = addresses.find(a => a.isDefault);
        setSelectedAddressForOrder(defaultAddr?._id || null);
    };

    const getuserAddress = async () => {
        setLoading(true);
        try {
            const profiledata = await userProfile();
            const fetchedAddresses = profiledata.data.user.addresses || [];
            setAddress(fetchedAddresses);
            setAddressData(fetchedAddresses);
            autoSelectAddress(fetchedAddresses);
        } catch (error) {
            console.log("error", error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { getuserAddress(); }, []);

    const fetchPincodeDetails = async (pincode) => {
        try {
            const response = await axios.get(`https://api.postalpincode.in/pincode/${pincode}`);
            const data = response.data?.[0];
            if (data?.Status === "Success" && Array.isArray(data.PostOffice) && data.PostOffice.length > 0) {
                const postOffice = data.PostOffice[0];
                return { city: postOffice.District || "", state: postOffice.State || "" };
            }
            return { state: "", city: "" };
        } catch (error) {
            console.error("Failed to fetch pincode details:", error);
            return { state: "", city: "" };
        }
    };

    const userDeleteAddress = async (address) => {
        const addressId = address._id;
        const isDefault = address.isDefault;

        if (isDefault) {
            await Swal.fire({
                title: "Default Address",
                text: "You cannot delete the default address. Please set another address as default first.",
                icon: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "OK",
            });
        } else {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "Are you sure you want to delete this address?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "Cancel",
            });
            if (result.isConfirmed) {
                try {
                    await deleteAddress(addressId);
                    await getuserAddress(); // ✅ API re-fetch handles selection automatically
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    Swal.fire({
                        title: "Deleted!",
                        text: "Address deleted successfully.",
                        icon: "success",
                        timer: 3000,
                        showConfirmButton: false,
                    });
                } catch (error) {
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete address.",
                        icon: "error",
                        timer: 3000,
                        showConfirmButton: false,
                    });
                }
            }
        }
    };

    const scrollToTopNow = () => {
        window.scrollTo({ top: 0, behavior: 'auto' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    };

    // ✅ Add / Edit submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const storedData = localStorage.getItem("userData");
            const token = storedData ? JSON.parse(storedData).token : null;
            if (!token) { alert("User not logged in."); return; }
            if (!formData.fullName || !formData.phone || !formData.address || !formData.city || !formData.state || !formData.houseName || !formData.pincode) {
                alert("Please fill all required fields."); return;
            }

            if (isEditing && formData.addressId) {
                // ── EDIT ──
                const res = await api.put(`/user/update-address`, formData, {
                    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
                });

                if (res.data.addresses) {
                    handleCloseModal();
                    await getuserAddress();
                    scrollToTopNow();
                    Swal.fire({
                        title: "Updated!",
                        text: "Address updated successfully.",
                        icon: "success",
                        timer: 2000,
                        showConfirmButton: false,
                        heightAuto: false,
                        scrollbarPadding: false,
                        returnFocus: false,
                        didOpen: () => scrollToTopNow(),
                        willClose: () => scrollToTopNow(),
                        didClose: () => {
                            scrollToTopNow();
                            setTimeout(scrollToTopNow, 50);
                            setTimeout(scrollToTopNow, 300);
                        },
                    });
                }
            } else {
                // ── ADD ──
                const res = await api.post("/user/add-address", formData, {
                    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
                });

                if (res.data.addresses || res.data.success) {
                    await getuserAddress(); // ✅ Re-fetch; autoSelectAddress picks isDefault
                    Swal.fire({
                        title: "Added!",
                        text: "Address added successfully.",
                        icon: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                }
            }

            handleCloseModal();
        } catch (err) {
            console.error("Error saving address:", err);
            Swal.fire({
                title: "Error",
                text: err?.response?.data?.message || "Something went wrong.",
                icon: "error",
                timer: 2500,
                showConfirmButton: false,
            });
        }
    };

    const handleChange = async (e) => {
        const { name, type, value, checked } = e.target;
        setFormData((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
        if (name === "pincode" && value.length === 6) {
            const details = await fetchPincodeDetails(value);
            setFormData((prev) => ({ ...prev, pincode: value, city: details.city, state: details.state }));
        }
    };

    const useMyLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;
                    await fetchAddressFromCoords(latitude, longitude);
                },
                () => { alert("Unable to fetch location. Please enable GPS."); },
                { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
            );
        } else {
            alert("Geolocation is not supported by your browser.");
        }
    };

    const fetchAddressFromCoords = async (lat, lng) => {
        try {
            const apiKey = "AIzaSyCehbIPolbjxmoJobmJv0_8WaAYN504fOE";
            const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${Number(lat)},${Number(lng)}&key=${apiKey}`);
            const data = await res.json();
            if (data.status === "OK" && data.results.length > 0) {
                const result = data.results[0];
                const components = result.address_components;
                const streetNumber = components.find(c => c.types.includes("street_number"))?.long_name || "";
                const route = components.find(c => c.types.includes("route"))?.long_name || "";
                const city = components.find(c => c.types.includes("locality"))?.long_name || "";
                const state = components.find(c => c.types.includes("administrative_area_level_1"))?.long_name || "";
                const country = components.find(c => c.types.includes("country"))?.long_name || "";
                const pincode = components.find(c => c.types.includes("postal_code"))?.long_name || "";
                const houseName = streetNumber && route ? `${streetNumber}, ${route}` : route || streetNumber || "";
                setFormData(prev => ({
                    ...prev,
                    latitude: lat, longitude: lng,
                    address: result.formatted_address || "",
                    houseName, city, state, country, pincode,
                }));
            }
        } catch (err) {
            console.error("Error fetching address:", err);
        }
    };

    // ✅ Select address — calls API to set isDefault, then re-fetches
    const handleSelectAddress = async (addr) => {
        try {
            if (!addr || !addr._id) throw new Error("Invalid address data");

            const storedData = localStorage.getItem("userData");
            const token = storedData ? JSON.parse(storedData).token : null;

            await api.put(
                "/user/updateAddressDefault",
                { addressId: addr._id },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            await getuserAddress(); // ✅ Re-fetch; autoSelectAddress picks new isDefault
            scrollToTopNow();

            Swal.fire({
                title: "Address Selected",
                text: "This address will be used for your order delivery.",
                icon: "success",
                timer: 1500,
                showConfirmButton: false,
                heightAuto: false,
                scrollbarPadding: false,
                returnFocus: false,
                didOpen: () => scrollToTopNow(),
                willClose: () => scrollToTopNow(),
                didClose: () => {
                    scrollToTopNow();
                    setTimeout(scrollToTopNow, 50);
                    setTimeout(scrollToTopNow, 300);
                },
            });
        } catch (error) {
            Swal.fire({
                title: "Something went wrong",
                text: "Failed to select this address.",
                icon: "error",
            });
        }
    };

    const handleEdit = (addr) => {
        setFormData({ ...addr, addressId: addr._id });
        setIsEditing(true);
        handleOpenModal();
    };

    const AddressContent = () => (
        <>
            <div className="top-action-bar" style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <button
                    className="back-btn"
                    onClick={() => navigate(-1)}
                    style={{
                        display: 'inline-flex', alignItems: 'center', gap: '6px',
                        background: 'transparent', border: '2px solid rgb(186 137 15)', color: 'rgb(186 137 15)',
                        borderRadius: '8px', padding: '10px 16px', fontSize: '14px',
                        fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.background = '#f0f0f0'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
                >
                    ‹ Back
                </button>
                <button className="add-address-btn" onClick={handleOpenModal} style={{ marginBottom: '0' }}>
                    <FaPlus size={13} /> Add New Address
                </button>
            </div>

            {loading ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    <p style={{ marginTop: '12px' }}>Loading addresses...</p>
                </div>
            ) : address.length > 0 ? (
                <div className="address-grid">
                    {[...address].sort((a, b) => (b.isDefault ? 1 : 0) - (a.isDefault ? 1 : 0)).map((addr) => (
                        <div
                            key={addr._id}
                            className={`address-card ${addr.isDefault ? 'selected-card' : ''}`}
                            onClick={() => handleSelectAddress(addr)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div>
                                <div className="address-card-header">
                                    <FaMapMarkerAlt size={16} color="#007bff" style={{ marginTop: '3px', flexShrink: 0 }} />
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        {addr.addressType && (
                                            <span className="address-type-badge">{addr.addressType || 'Home'}</span>
                                        )}
                                        <p className="address-name">{addr.fullName}</p>
                                        <p className="address-detail">{addr.houseName}</p>
                                        <p className="address-detail">{addr.address}</p>
                                        {addr.landmark && <p className="address-detail">Near: {addr.landmark}</p>}
                                        <p className="address-detail">{addr.city}, {addr.state} - {addr.pincode}</p>
                                        <p className="address-detail">📞 {addr.phone}</p>
                                        {addr.isDefault && (
                                            <span className="default-badge">✓ Default</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="address-actions">
                                <button
                                    className="addr-edit-btn"
                                    onClick={(e) => { e.stopPropagation(); handleEdit(addr); }}
                                >
                                    <FaEdit size={13} /> Edit
                                </button>
                                <button
                                    className="addr-delete-btn"
                                    onClick={(e) => { e.stopPropagation(); userDeleteAddress(addr); }}
                                >
                                    <FaTrash size={13} /> Remove
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="empty-state">
                    <div className="empty-state-icon">📍</div>
                    <p>No saved addresses found.</p>
                    <p style={{ fontSize: '13px', marginTop: '6px' }}>Click "Add New Address" to get started.</p>
                </div>
            )}
        </>
    );

    return (
        <>
            <style>{`
                .modal-overlay {
                    position: fixed; inset: 0; background: rgba(0,0,0,0.5);
                    z-index: 1100; display: flex; align-items: center;
                    justify-content: center; padding: 16px;
                }
                .modal-content {
                    background: #fff; border-radius: 12px; padding: 28px 24px;
                    width: 100%; max-width: 520px; max-height: 90vh;
                    overflow-y: auto; box-shadow: 0 8px 32px rgba(0,0,0,0.18);
                }
                .modal-content h3 { font-size: 18px; font-weight: 600; color: #333; margin: 0 0 20px; }
                .form-group { margin-bottom: 14px; display: flex; flex-direction: column; gap: 5px; }
                .form-group label { font-size: 13px; font-weight: 500; color: #555; }
                .form-group input, .form-group select, .form-group textarea {
                    padding: 10px 12px; border: 1px solid #ddd; border-radius: 7px;
                    font-size: 14px; outline: none; transition: border-color 0.2s;
                    width: 100%; box-sizing: border-box;
                }
                .form-group input:focus, .form-group select:focus, .form-group textarea:focus {
                    border-color: #007bff; box-shadow: 0 0 0 3px rgba(0,123,255,0.1);
                }
                .form-group textarea { min-height: 80px; resize: vertical; }
                .form-group input[type="checkbox"] { width: auto; margin-right: 8px; }
                .form-group label:has(input[type="checkbox"]) {
                    flex-direction: row; align-items: center; font-size: 14px; cursor: pointer;
                }
                .form-actions { display: flex; gap: 10px; margin-top: 18px; flex-wrap: wrap; }
                .form-actions button {
                    flex: 1; padding: 11px; border-radius: 7px; font-size: 14px;
                    font-weight: 500; cursor: pointer; border: none; transition: all 0.2s;
                }
                .btn-submit { background: #007bff; color: #fff; }
                .btn-submit:hover { background: #0056b3; }
                .btn-cancel { background: #f0f0f0; color: #555; border: 1px solid #ddd !important; }
                .btn-cancel:hover { background: #e0e0e0; }
                .use-location-btn {
                    display: inline-flex; align-items: center; gap: 6px;
                    background: transparent; border: 1px solid #28a745; color: #28a745;
                    border-radius: 6px; padding: 7px 14px; font-size: 13px;
                    cursor: pointer; transition: all 0.2s; margin-bottom: 12px;
                }
                .use-location-btn:hover { background: #28a745; color: #fff; }
                .dashboard-wrapper { display: flex; min-height: 80vh; padding: 20px; gap: 20px; }
                .dashboard-content { flex: 1; min-width: 0; }
                .add-address-btn {
                    display: inline-flex; align-items: center; gap: 8px;
                    background: #c4900f; color: #fff; border: none; border-radius: 8px;
                    padding: 11px 20px; font-size: 14px; font-weight: 500;
                    cursor: pointer; transition: background 0.2s; margin-bottom: 20px;
                }
                .add-address-btn:hover { background: #0056b3; }
                .address-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 16px; }
                .address-card {
                    background: #fff; border-radius: 10px;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.07);
                    border: 1px solid #f0f0f0; padding: 18px;
                    display: flex; flex-direction: column;
                    justify-content: space-between; gap: 14px;
                    transition: all 0.2s;
                }
                /* ✅ Only isDefault from API drives the selected style */
                .address-card.selected-card {
                    border: 2px solid #28a745 !important;
                    background: #f6fff8;
                    box-shadow: 0 0 0 4px rgba(40,167,69,0.12);
                }
                .address-card-header { display: flex; align-items: flex-start; gap: 10px; }
                .address-type-badge {
                    display: inline-block; padding: 2px 10px; border-radius: 20px;
                    font-size: 11px; font-weight: 600; background: #e8f0fe;
                    color: #1a56db; margin-bottom: 6px; text-transform: capitalize;
                }
                .address-name { font-size: 15px; font-weight: 600; color: #333; margin: 0 0 4px; }
                .address-detail { font-size: 13px; color: #666; margin: 2px 0; line-height: 1.5; }
                .default-badge {
                    display: inline-block; padding: 2px 10px; background: #28a745;
                    color: #fff; border-radius: 20px; font-size: 11px;
                    font-weight: 600; margin-top: 6px;
                }
                .address-actions { display: flex; gap: 8px; }
                .addr-edit-btn {
                    flex: 1; padding: 8px; background: transparent; color: #007bff;
                    border: 1px solid #007bff; border-radius: 6px; font-size: 13px;
                    cursor: pointer; display: flex; align-items: center;
                    justify-content: center; gap: 6px; transition: all 0.2s;
                }
                .addr-edit-btn:hover { background: #007bff; color: #fff; }
                .addr-delete-btn {
                    flex: 1; padding: 8px; background: transparent; color: #dc3545;
                    border: 1px solid #dc3545; border-radius: 6px; font-size: 13px;
                    cursor: pointer; display: flex; align-items: center;
                    justify-content: center; gap: 6px; transition: all 0.2s;
                }
                .addr-delete-btn:hover { background: #dc3545; color: #fff; }
                .empty-state { text-align: center; padding: 50px 20px; color: #888; font-size: 15px; }
                .empty-state-icon { font-size: 48px; margin-bottom: 12px; }
                .acct-mobile-only-wrapper { display: none; }
                .wl-mob-header {
                    display: flex; align-items: center; justify-content: space-between;
                    padding: 13px 16px; background: #fff; border-bottom: 1px solid #f0f0f0;
                    position: sticky; top: 0; z-index: 10;
                }
                .wl-mob-back-btn {
                    width: 36px; height: 36px; border: none; background: none;
                    font-size: 28px; color: #333; cursor: pointer;
                }
                .wl-mob-title { font-size: 16px; font-weight: 700; color: #111; margin: 0; }
                .wl-mob-body { padding: 16px; background: #fff; min-height: auto; }
                @media (max-width: 768px) {
                    .acct-mobile-only-wrapper { display: block; }
                    .dashboard-wrapper { display: none !important; }
                    .address-grid { grid-template-columns: 1fr; }
                    .top-action-bar { width: 100%; flex-wrap: nowrap; }
                    .top-action-bar .add-address-btn { flex: 1; justify-content: center; margin-bottom: 0; }
                    .top-action-bar .back-btn { white-space: nowrap; flex-shrink: 0; }
                }
                @media (min-width: 769px) {
                    .wl-mob-content-panel { display: none !important; }
                    .dashboard-wrapper { display: flex !important; }
                }
            `}</style>

            {showModal && (
                <div
                    className="modal-overlay"
                    onClick={(e) => { if (e.target.classList.contains('modal-overlay')) handleCloseModal(); }}
                >
                    <div className="modal-content">
                        <h3>{isEditing ? "Edit Address" : "Add New Address"}</h3>
                        <form onSubmit={handleSubmit}>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '12px' }}>
                                <button type="button" className="use-location-btn" onClick={useMyLocation}>
                                    <FaMapMarkerAlt size={13} /> Use My Location
                                </button>
                            </div>
                            <div className="form-group">
                                <label>Full Name *</label>
                                <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} placeholder="Enter your full name" required />
                            </div>
                            <div className="form-group">
                                <label>Mobile Number *</label>
                                <input type="text" name="phone" value={formData.phone} onChange={handleChange} placeholder="Enter your mobile number" required />
                            </div>
                            <div className="form-group">
                                <label>Pincode *</label>
                                <input type="text" name="pincode" value={formData.pincode} onChange={handleChange} placeholder="Enter pincode (auto-fills city & state)" required maxLength={6} />
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                                <div className="form-group">
                                    <label>City *</label>
                                    <input type="text" name="city" value={formData.city} onChange={handleChange} placeholder="City" required />
                                </div>
                                <div className="form-group">
                                    <label>State *</label>
                                    <input type="text" name="state" value={formData.state} onChange={handleChange} placeholder="State" required />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>House / Building Name *</label>
                                <input type="text" name="houseName" value={formData.houseName} onChange={handleChange} placeholder="House no., building name" required />
                            </div>
                            <div className="form-group">
                                <label>Full Address *</label>
                                <textarea name="address" value={formData.address} onChange={handleChange} placeholder="Street, area, locality" required />
                            </div>
                            <div className="form-group">
                                <label>Landmark</label>
                                <input type="text" name="landmark" value={formData.landmark} onChange={handleChange} placeholder="Nearby landmark (optional)" />
                            </div>
                            <div className="form-group">
                                <label>Address Type</label>
                                <select name="addressType" value={formData.addressType} onChange={handleChange}>
                                    <option value="">Home</option>
                                    <option value="Work">Office</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>
                                    <input type="checkbox" name="isDefault" checked={formData.isDefault} onChange={handleChange} />
                                    Set as Default Address
                                </label>
                            </div>
                            <div className="form-actions">
                                <button type="submit" className="btn-submit">
                                    {isEditing ? "Update Address" : "Add Address"}
                                </button>
                                <button type="button" className="btn-cancel" onClick={handleCloseModal}>Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            <main className="main__content_wrapper">
                <div className="acct-mobile-only-wrapper">
                    <AccountSidebar
                        mobileView={mobileView}
                        setMobileView={setMobileView}
                        activeMobilePath="/my-address"
                        contentViewName="content"
                    />
                </div>

                <div className="wl-mob-content-panel" style={{ display: mobileView === "content" ? "block" : "none" }}>
                    <div className="wl-mob-header">
                        <button className="wl-mob-back-btn" onClick={() => setMobileView("menu")}>‹</button>
                        <h2 className="wl-mob-title">My Address</h2>
                        <div style={{ width: 36 }} />
                    </div>
                    <div className="wl-mob-body"><AddressContent /></div>
                </div>

                <div className="container-fluid">
                    <div className="dashboard-wrapper">
                        <AccountSidebar
                            mobileView={mobileView}
                            setMobileView={setMobileView}
                            activeMobilePath="/my-address"
                            contentViewName="content"
                        />
                        <div className="dashboard-content"><AddressContent /></div>
                    </div>
                </div>
            </main>

            <Footer />

            <button
                onClick={handleScrollTop}
                style={{
                    position: 'fixed', bottom: '30px', right: '30px', width: '46px', height: '46px',
                    borderRadius: '50%', backgroundColor: '#ceb256', color: '#fff', border: 'none',
                    zIndex: 1000, cursor: 'pointer', display: isVisible ? 'flex' : 'none',
                    alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" height="22" width="22" viewBox="0 0 512 512" fill="none" stroke="currentColor" strokeWidth="48" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M112 244l144-144 144 144" />
                    <path d="M256 120v292" />
                </svg>
            </button>
        </>
    );
};

export default MyAddress;